import React from 'react'
import { Translate } from 'react-redux-i18n';
import {
    Button, 
} from "@blueprintjs/core";
import Moment from 'react-moment';
import Image from '../Image';
import SendMessageDecorator from "../../containers/SendMessageDecorator";

const UserPublicProfile=({user, myGuid})=>{
  return (
    <div className="wide-content public-profile">
        <h1 className="sidebar-heading">
            {user.f_name}
            <Translate value="public_profile.profile" />
        </h1>
        <div className="custom-card">
            <div className="user-meta">
                <div className="avatar">
                    <Image src={user.image_url} alt={user.f_name} />                   
                </div>
                <div className="name">
                    <h1>{user.f_name} {user.l_name}</h1>
                    <p>
                        <span>
                            <Translate value="public_profile.member_since"/>
                        </span>
                        <time>                             
                            <Moment date={user.c_at} format="MMMM D, YYYY" />
                        </time>
                    </p>
                    {!(myGuid === user.guid) &&
                        <SendMessageDecorator user_guid={user.guid} >
                            <div className="cta-wrapper">
                                <Button intent="primary" className="secondary-color small" >
                                    <Translate value="public_profile.send_message" />
                                </Button>
                            </div>
                        </SendMessageDecorator>
                    }
                </div>
            </div>
            <div>
                <strong className="black-color">
                    <Translate value="public_profile.location" />
                </strong>
                <p className="small">{user.address}</p>
                <hr />
                {user.description && 
                    <>
                        <strong className="black-color">
                            <Translate value="public_profile.about" />
                            {user.f_name}
                        </strong>
                        <p className="small">{user.description}</p>
                    </>
                }
            </div>
        </div>
    </div>
  )
}
export default UserPublicProfile;